import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatPrice } from "../../helpers/formattedPrice";
import { baseUrl } from "../../services";

const STATUS_STYLES = {
  1: { bg: "#FFCC0033", color: "#FFCC00", key: "statusPending" },
  2: { bg: "#DEF9D5", color: "#60EC2F", key: "statusAccepted" },
  3: { bg: "#FFE5E5", color: "#FF4D4F", key: "statusRejected" },
  4: { bg: "#D6EAF8", color: "#2E86C1", key: "statusCollected" },
};

const OrderCard = ({ data }) => {
  const { authorization } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const currency = authorization?.isEmirate
    ? t("buyAndSupply.aed")
    : t("buyAndSupply.egp");
  const statusStyle = STATUS_STYLES[data?.statusId] || STATUS_STYLES[1];
  const statusLabel = t(`buyAndSupply2026.${statusStyle.key}`);

  const walletDeduction = Number(data?.walletDeduction) || 0;
  const showWalletRows = walletDeduction > 0;
  const deliveryDate = data?.deliveryDate;

  const rows = [
    {
      label: t("buyAndSupply2026.quantity"),
      value: data?.quantity,
    },
    {
      label: t("buyAndSupply2026.totalPurchase"),
      value: `${formatPrice(data?.totalPurchase)} ${currency}`,
    },
    {
      label: t("buyAndSupply2026.totalSupplyPrice"),
      value: `${formatPrice(data?.totalSupplyPrice)} ${currency}`,
    },
    ...(deliveryDate
      ? [
          {
            label: t("buyAndSupply2026.moneyReceivingDate"),
            value: deliveryDate,
          },
        ]
      : []),
    ...(showWalletRows
      ? [
          {
            label: t("buyAndSupply2026.walletDeductionAmount"),
            value: `${formatPrice(data?.walletDeduction)} ${currency}`,
          },
          {
            label: t("buyAndSupply2026.priceAfterWalletDeduction"),
            value: `${formatPrice(data?.priceAfterWalletDeduction)} ${currency}`,
          },
        ]
      : []),
  ];

  return (
    <article className="buy-supply-2026-order-card h-100">
      <img
        src={baseUrl + data?.image}
        alt={data?.itemName || ""}
        className="buy-supply-2026-order-card__image"
        loading="lazy"
      />
      <div className="buy-supply-2026-order-card__body">
        <div className="buy-supply-2026-order-card__header">
          <h2 className="buy-supply-2026-order-card__title">
            {data?.itemName}
          </h2>
          <span
            className="buy-supply-2026-order-card__status"
            style={{
              backgroundColor: statusStyle.bg,
              color: statusStyle.color,
            }}
          >
            {statusLabel}
          </span>
        </div>

        <ul className="buy-supply-2026-order-card__rows">
          {rows.map((row) => (
            <li key={row.label} className="buy-supply-2026-order-card__row">
              <span className="buy-supply-2026-order-card__label">
                {row.label}
              </span>
              <span className="buy-supply-2026-order-card__value">
                {row.value}
              </span>
            </li>
          ))}
        </ul>

        <p className="buy-supply-2026-order-card__date">
          {data?.creationDate || ""}
        </p>
      </div>
    </article>
  );
};

export default OrderCard;
